import { useSelector } from "react-redux";
import { setRowData } from "store/slice/search.slice";
import cx from "classnames";
import "styles/modal-content.scss";
import { ASRType } from "types/molecules.types";
import useItToCopyClipboard from "hooks/useItToCopyClipboard";

import * as Icons from 'constants/icons'

const ASRDetails = () => {
  const selectedRow = useSelector(setRowData);
  const data: ASRType = selectedRow.payload.search.selectedRow;
  const [isCopied, copy] = useItToCopyClipboard();
  const copiedClass = cx("copy-section", { copied: isCopied });
  const asrDetails = [
    {
      title: "Partner:",
      value: (
        <>
          <span>{data.account_number ?? 'N/A'}</span>
          <span className={copiedClass}>
            {isCopied ? (
              <span>Copied</span>
            ) : ( data.account_number &&
              <img
                className="image_style"
                src={Icons.copy}
                alt="Copy"
                onClick={() => copy(data.account_number)}
              />
            )}
          </span>
        </>
      ),
    },
    {
      title: "NPS:",
      value: data.nps,
    },
    {
      title: "Phone:",
      value: data.phone,
    },
    {
      title: "Email:",
      value: data.email ? <a href={`mailto:${data.email}`}>{data.email}</a> : 'N/A',
    },
    {
      title: "Address:",
      value: data.address+" "+data.city+" "+data.state+" "+data.country+" "+data.zip_postal,
    },
    {
      title: "City:",
      value: data.city,
    },
    {
      title: "Expertise:",
      value: data?.SkillId.join(', ')
    },
  ];

 const sanitizeText = (text: string) => text.replace(/<\/?[^>]+(>|$)/g, '');

  return (
    <div className="modal_data">
      <h1 className="title">{data.partner_name}</h1>
      <div className="row">
        {asrDetails.map((detail, i) => (
          <section key={i}>
            <div className="name">{detail.title}</div>
            <div className="value">{detail.value ? detail.value : "N/A"}</div>
          </section>
        ))}
      </div>
      <div className="asr_latest_comments">ASR Latest Comments</div>
      <div className="comments">
      {data.comments ? sanitizeText(data.comments) : 'N/A'}
      </div>
    </div>
  );
};

export default ASRDetails;
